<template>
    <template v-if="movement.driver">
        <p class="mb-0">
            Currently assigned to <a :href="generateDriverShowRoute()">{{ movement.driver.name }}</a>
            (
                {{ movement.transported ? 'Transported' : 'Driven' }}
                <span v-if="movement.status !== 'assigned'">
                    {{ movement.status }}
                </span>
            )
            <button class="btn btn-sm btn-secondary ms-2" @click="toggleTransportedOrDelivered()">
                Set {{ !movement.transported ? 'Transported' : 'Driven' }}
            </button>
        </p>
    </template>
    <template v-else>
        <p class="mb-0">Unassigned</p>
    </template>
</template>

<script setup>
import { inject, watch } from 'vue';
import axios from 'axios';

const movement = defineModel();
const emit = defineEmits(['update:movement']);
const markLocalMovementMutation = inject('markLocalMovementMutation', null);

watch(movement, (newVal) => {
    emit('update:movement', newVal);
});

function generateDriverShowRoute() {
    return route('movements.drivers.show', movement.value.driver.id);
}

function toggleTransportedOrDelivered() {
    if (markLocalMovementMutation && movement.value?.id) {
        markLocalMovementMutation([movement.value.id]);
    }

    axios.post(route('api.movements.movements.toggle-transported', movement.value.id))
        .then(response => {
            movement.value.transported = response.data.transported;
        }).catch(error => {
            console.error('Error updating transported status:', error);
        });
}
</script>
